<template>
    <div v-show="visible">
        <el-dialog title="新增" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="380px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">

                <el-form-item  v-if="isNature" prop="name" label="学校名称">
                    <el-input v-model="form.name" maxlength="200"  style="width: 200px;"></el-input>
                </el-form-item>

                <el-form-item  v-else prop="name" label="组织名称">
                    <el-input v-model="form.name" maxlength="200"  style="width: 200px;"></el-input>
                </el-form-item>

                <el-form-item   prop="nature" label="类型" v-if="isNature">
                    <el-select v-model="form.nature" clearable placeholder="请选择"  style="width: 200px;">
                        <el-option
                            v-for="item in natures"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item   prop="deptControllerLabel" label="学校负责人">
                     <el-input placeholder="请选择人名" :readonly="true" v-model="form.deptControllerLabel"  style="width: 200px;" class="input-with-select">
                        <el-button slot="append" icon="el-icon-search" @click="findUser()"></el-button>
                    </el-input>
                </el-form-item>

                <el-form-item   prop="orderNum" label="排序号">
                    <el-input v-model="form.orderNum" maxlength="2" type="number"  style="width: 200px;"></el-input>
                </el-form-item>
            
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取消</el-button>
                <el-button type="primary" @click="save()">确定</el-button>
            </span>    
        </el-dialog>
        <!-- 人员弹出框 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import userTransfer from '../user/UserTransfer.vue';

    export default {
        data(){
            return{
                visible: false,
                isNature:false,
                transferVisible:false,
                form:{
                    parentId:"",
                    number:"",
                    name:"",
                    belongSubsectionid:"",
                    nature:"",
                    deptController:"",
                    deptControllerLabel: "",
                    parentIdStr:"",
                    orderNum:1
                },
                natures: [{
                    value: '1',
                    label: '幼儿园'
                }, {
                    value: '2',
                    label: '小学'
                }, {
                    value: '3',
                    label: '中学'
                }, {
                    value: '4',
                    label: '其他'
                }],
                rules: {
                    name: [
                        { required: true, message: '请输入学校名称', trigger: 'blur' }
                    ],
                    nature: [
                        { required: true, message: '请选择类型', trigger: 'blur' }
                    ]
                }
            }
        },
        components: {
            userTransfer
        },
        created:function () {
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                // console.log(JSON.stringify(data));
                //初始值
                if(this.$util.isNotEmpty(data)){
                    this.form.parentId=data.id;
                    if(this.$util.isNotEmpty(data.attributes.belongSubsectionid)){
                        this.form.belongSubsectionid=data.attributes.belongSubsectionid;
                    }
                    this.form.parentIdStr=data.attributes.parentIdStr;
                    this.form.nature=data.attributes.nature;
                    this.isNature=false;
                }else{
                    this.form.parentId="0";
                    this.form.belongSubsectionid="0";
                    this.form.parentIdStr="";
                    this.form.nature="";
                    this.isNature=true;
                }
                this.form.deptController='';
                this.form.deptControllerLabel='';
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.deptAddUrl;
                        let data = {
                            parentId:this.form.parentId,
                            number:this.form.number,
                            name:this.form.name,
                            belongSubsectionid:this.form.belongSubsectionid,
                            nature:this.form.nature,
                            deptController:this.form.deptController,
                            parentIdStr:this.form.parentIdStr,
                            orderNum:this.$util.isNotEmpty(this.form.orderNum)?this.form.orderNum:"",
                        };
                        // console.log(JSON.stringify(data));
                        this.apiPost(url, data).then((res) => {
                            if(res.status == 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            },
            findUser(){
                this.transferVisible=true;
                this.$nextTick(() => {
                    if(this.$util.isNotEmpty(this.form.deptController)){
                        let val=new Array();
                        val.push(this.form.deptController);
                        this.$refs['userTransfer'].init(2,val,1,this.form.belongSubsectionid);
                    }else{
                        this.$refs['userTransfer'].init(2,null,1,this.form.belongSubsectionid);
                    }
                })
            },
            setUser(key,label){
                this.form.deptController = key;
                this.form.deptControllerLabel = label;
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/sys/dept/Add.vue